/** Used for venue settings related currency code, symbol and fraction. Follows https://angular.io/api/common/CurrencyPipe */
export interface ICurrencySettings {
  currencyCode: string;
  currencySymbol: string;
  currencyFractionSize: string; // {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits} e.g. 1.2-2
}

export const CBlankCurrency: ICurrencySettings = {
  currencyCode: 'USD',
  currencySymbol: '$',
  currencyFractionSize: '1.2-2'
};
